// ajaxURL
import { ajaxURL, loginRedirect } from './variables.js';

window.addEventListener('load', function() {
        // .okopunkt__recommendation-entry
        // get all elements with class name okopunkt__recommendation-entry
    
        let recommendations = document.querySelectorAll('.okopunkt__recommendation-entry');
        if(recommendations.length > 0) {
            recommendations.forEach((recommendation) => {
                // get data via ajax request

                let data = new FormData();
                data.append('action', 'da_recommendations');

                fetch(ajaxURL, {
                    method: 'POST',
                    body: data
                })
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    // if the server responds with success, we reload the page
                    // redirect to the login redirect page
                    // window.location.href = loginRedirect;
                    recommendation.innerHTML = data.message;
                });

            });
        }

});